export default __webpack_public_path__ + "static/media/fisa-logo-white.fc6432a5.png";